import { render, staticRenderFns } from "./suporte-whatsapp-card.vue?vue&type=template&id=13d90439&scoped=true&"
import script from "./suporte-whatsapp-card.vue?vue&type=script&lang=js&"
export * from "./suporte-whatsapp-card.vue?vue&type=script&lang=js&"
import style0 from "./suporte-whatsapp-card.vue?vue&type=style&index=0&id=13d90439&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d90439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d90439')) {
      api.createRecord('13d90439', component.options)
    } else {
      api.reload('13d90439', component.options)
    }
    module.hot.accept("./suporte-whatsapp-card.vue?vue&type=template&id=13d90439&scoped=true&", function () {
      api.rerender('13d90439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/suporte-whatsapp/suporte-whatsapp-card.vue"
export default component.exports